import {
	DensityUnit,
	LengthUnit,
	PressureUnit,
	RigType,
	TemperatureUnit
} from '@fastsheep/densicalc-core';
import { DEFAULT_UNITS } from '../utils/UnitUtils';
import DefaultUnitRepository from '../repositories/DefaultUnitRepository';
import { DefaultUnits } from './DefaultUnits';

export type DensiCalcData = {
	density: string;
	densityUnit: DensityUnit;
	measuredAtTemp: string;
	measuredAtTempUnit: TemperatureUnit;
	referenceTemperature: string;
	referenceTemperatureUnit: TemperatureUnit;
	resultDensity: string;
	resultDensityUnit: DensityUnit;
	densityAtRefTemp: string;
	densityAtRefTempUnit: DensityUnit;
	rigType: RigType;
	airgap: string;
	airgapUnit: LengthUnit;
	rkbToFlowline: string;
	rkbToFlowlineUnit: LengthUnit;
	waterDepth: string;
	waterDepthUnit: LengthUnit;
	surfaceTemperature: string;
	surfaceTemperatureUnit: TemperatureUnit;
	seabedTemperature: string;
	seabedTemperatureUnit: TemperatureUnit;
	downholeTemperature: string;
	downholeTemperatureUnit: TemperatureUnit;
	downholeTempMeasuredAtDepth: string;
	downholeTempMeasuredAtDepthUnit: LengthUnit;
	analysisPoint: string;
	analysisPointUnit: LengthUnit;
	averageRiserDensity: string;
	averageRiserDensityUnit: DensityUnit;
	fluidPressureAtSeabed: string;
	fluidPressureAtSeabedUnit: PressureUnit;
	riserMargin: string;
	riserMarginUnit: DensityUnit;
	avgDensityAboveTvd: string;
	avgDensityAboveTvdUnit: DensityUnit;
	pressureAtTvd: string;
	pressureAtTvdUnit: PressureUnit;
	temperatureAtTvd: string;
	temperatureAtTvdUnit: TemperatureUnit;
};

export const getEmptyDensiCalcData = (): DensiCalcData => {
	const savedDefaultUnits = DefaultUnitRepository.findDefaultUnits();
	const defaultUnits: DefaultUnits = {
		densityUnit:
			savedDefaultUnits !== null
				? savedDefaultUnits.densityUnit
				: DEFAULT_UNITS.DENSITY,
		pressureUnit:
			savedDefaultUnits !== null
				? savedDefaultUnits.pressureUnit
				: DEFAULT_UNITS.PRESSURE,
		temperatureUnit:
			savedDefaultUnits !== null
				? savedDefaultUnits.temperatureUnit
				: DEFAULT_UNITS.TEMPERATURE,
		lengthUnit:
			savedDefaultUnits !== null
				? savedDefaultUnits.lengthUnit
				: DEFAULT_UNITS.LENGTH
	};

	return {
		density: '',
		densityUnit: defaultUnits.densityUnit,
		measuredAtTemp: '',
		measuredAtTempUnit: defaultUnits.temperatureUnit,
		referenceTemperature: '',
		referenceTemperatureUnit: defaultUnits.temperatureUnit,
		resultDensity: '',
		resultDensityUnit: defaultUnits.densityUnit,
		densityAtRefTemp: '',
		densityAtRefTempUnit: defaultUnits.densityUnit,
		rigType: 'sea',
		airgap: '',
		airgapUnit: defaultUnits.lengthUnit,
		rkbToFlowline: '',
		rkbToFlowlineUnit: defaultUnits.lengthUnit,
		waterDepth: '',
		waterDepthUnit: defaultUnits.lengthUnit,
		surfaceTemperature: '',
		surfaceTemperatureUnit: defaultUnits.temperatureUnit,
		seabedTemperature: '',
		seabedTemperatureUnit: defaultUnits.temperatureUnit,
		downholeTemperature: '',
		downholeTemperatureUnit: defaultUnits.temperatureUnit,
		downholeTempMeasuredAtDepth: '',
		downholeTempMeasuredAtDepthUnit: defaultUnits.lengthUnit,
		analysisPoint: '',
		analysisPointUnit: defaultUnits.lengthUnit,
		averageRiserDensity: '',
		averageRiserDensityUnit: defaultUnits.densityUnit,
		fluidPressureAtSeabed: '',
		fluidPressureAtSeabedUnit: defaultUnits.pressureUnit,
		riserMargin: '',
		riserMarginUnit: defaultUnits.densityUnit,
		avgDensityAboveTvd: '',
		avgDensityAboveTvdUnit: defaultUnits.densityUnit,
		pressureAtTvd: '',
		pressureAtTvdUnit: defaultUnits.pressureUnit,
		temperatureAtTvd: '',
		temperatureAtTvdUnit: defaultUnits.temperatureUnit
	};
};
